import { Outlet } from 'react-router-dom';

const Retirement = () => {
    return (
        <>
            <Outlet />
        </>
    )
};

export default Retirement;